import { notification } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import { Button, Dimmer, Form, Input, Loader, Radio, Segment, TextArea } from 'semantic-ui-react';

import * as api from '../../../stores/api';
import customFetch from '../../../utils/customFetch';
import JobTitleStore from './JobTitleStore';

@observer
class FormAddEdit extends React.Component {
  state = {
    canEdit: api.isAdmin(),
  };

  handleChange = (_, { name, value }) => {
    const { dataJobTitle } = JobTitleStore;
    JobTitleStore.setFieldsValue({
      dataJobTitle: { ...dataJobTitle, [name]: value },
    });
  };

  handleChangeActive = () => {
    const { dataJobTitle } = JobTitleStore;
    const { isActive } = dataJobTitle;
    JobTitleStore.setFieldsValue({
      dataJobTitle: { ...dataJobTitle, isActive: !isActive },
    });
  };
  handSave = async () => {
    const { dataJobTitle } = JobTitleStore;
    let model = {};
    let url = '';
    model = {
      Description: dataJobTitle.descriptions,
      Id: dataJobTitle.id,
      IsActive: dataJobTitle.isActive,
      Label: dataJobTitle.name,
      OrderNo: 0,
      ParentId: null,
      SubList: null,
      Type: null,
    };
    url = '/JobTitle/SaveData';
    await customFetch(`${url}`, {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify(model),
    }).then(res => {
      if (res.status === 'success') {
        notification.destroy();
        notification.success({
          title: 'Success',
          message: 'Data has been saved successfully.',
        });
      }
    });
  };
  handleClose = () => {
    window.closeCurrentTab();
    JobTitleStore.onReset();
  };
  onClose = () => {
    return JobTitleStore.toggleModal(true, {
      modalType: 'confirm',
      message: 'All unsaved changes will be discarded. Do you want to continue?',
      onOk: () => this.handleClose(),
    })();
  };

  render() {
    const { dataJobTitle } = JobTitleStore;
    const data = dataJobTitle;
    const { canEdit } = this.state;

    return (
      <Segment size="massive">
        <Dimmer>
          <Loader />
        </Dimmer>
        <Form>
          <Form.Field>
            <label>Job Title Name</label>
            <Input placeholder="Job Title Name" value={data.name} name="name" onChange={this.handleChange} />
          </Form.Field>
          <Form.Field>
            <label>Description</label>
            <TextArea
              placeholder="Description"
              name="descriptions"
              className="text-area-description"
              onChange={this.handleChange}
              value={data.descriptions}
            />
          </Form.Field>
          <Form.Field>
            <label>Set Type Active</label>
            <Radio toggle checked={data.isActive} onChange={this.handleChangeActive} />
          </Form.Field>
          <Form.Group widths="equal">
            <Form.Field>
              <Button floated="right" className="negative" onClick={this.onClose}>
                Close
              </Button>
              {!api.isOnlySearch() && <Button floated="right" onClick={this.handSave} className="btn-primary-submit" disabled={!canEdit}>
                Save
              </Button>}
            </Form.Field>
          </Form.Group>
        </Form>
      </Segment>
    );
  }
}

export default FormAddEdit;
